import configStorage from '../../configuration/config-storage';
import { t } from '../../localization';
import getDomainPrices from './get-domain-prices';
import formatPrice from './format-price';

function processDomainsData({ prices, domains, currency, extraPrice, isSpecialOfferEnabled }) {
  const { locale = 'en' } = configStorage.get();

  if (!domains) {
    return null;
  }

  return domains.map((domainItem) => {
    let captions = {
      title: domainItem.domain,
      price: t('Taken'),
      button: t('Get'),
    };
    let specialOfferCaptions = {};

    let processedDomainItem = {
      ...domainItem,
      disabled: !domainItem.available,
      ...(!domainItem.available && { priceAppearance: 'low-emphasis' }),
    };

    if (domainItem.available) {
      const tld = domainItem.domain.split('.').slice(1).join('.');
      const priceData = prices && prices[tld];
      const priceValue = priceData && priceData['P1Y'].prices[currency];

      if (!priceValue && priceValue !== 0) {
        return {
          ...processedDomainItem,
          captions,
        };
      }

      const { price, oldPrice } = getDomainPrices({
        priceData,
        currency,
        extraPrice,
        isSpecialOfferEnabled,
      });

      processedDomainItem = {
        ...processedDomainItem,
        ...(isSpecialOfferEnabled && {
          buttonAppearance: 'accent',
          priceAppearance: 'success',
        }),
      };

      if (isSpecialOfferEnabled) {
        specialOfferCaptions = {
          ...(oldPrice && {
            oldPrice: formatPrice(oldPrice, currency, locale),
            priceDescription: t('with annual plan'),
            popoverTitle: t(
              'Get a free domain for 1 year. Offer valid for the following extensions: .com, .uk, .co.uk, .us, .it, .biz, .de, .nl, .eu, .in, .co.za, .club, .info, .work, .xyz'
            ),
          }),
        };
      }

      captions = {
        ...captions,
        price: formatPrice(price, currency, locale),
        priceDescription: t('with premium plans'),
        ...specialOfferCaptions,
      };
    }

    return {
      ...processedDomainItem,
      captions,
    };
  });
}

export default processDomainsData;
